import axios, { AxiosResponse, AxiosInstance, AxiosRequestConfig, Method, AxiosRequestHeaders } from "axios";

const getData = <T>(response: AxiosResponse<T>) => response.data;

const defaultTimeout = 10000;

export abstract class BaseHttpService {
  private readonly axiosClient: AxiosInstance;

  protected constructor (readonly baseURL?: string) {
    this.axiosClient = axios.create({
      baseURL: baseURL ?? process.env.REACT_APP_API_BASE_URL ?? "/",
      responseType: "json",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  public get(url: string, headers?: AxiosRequestHeaders){
    return this.request("get", url, undefined, headers);
  }

  protected post(url: string, data?: any, headers?: AxiosRequestHeaders){
    return this.request("post", url, data, headers);
  }

  protected patch(url: string, data?: any, headers?: AxiosRequestHeaders){
    return this.request("patch", url, data, headers);
  }

  protected put(url: string, data?: any, headers?: AxiosRequestHeaders){
    return this.request("put", url, data, headers);
  }

  protected delete(url: string, data?: any, headers?: AxiosRequestHeaders){
    return this.request("delete", url, data, headers);
  }

  protected request(method: Method, url: string, data?: any, headers?: AxiosRequestHeaders): Promise<any> {
    // eslint-disable-next-line import/no-named-as-default-member
    const source = axios.CancelToken.source();

    const config: AxiosRequestConfig = {
      method,
      url,
      data,
      headers,
      cancelToken: source.token
    };

    setTimeout(() => {
      source.cancel("Internal Server Error");
    }, defaultTimeout);

    return this.axiosClient
      .request(config)
      .then(getData);
  }
}
